import { createRequest } from '@savgroup-front-common/core/services/request';

export enum ACTION_TYPES {
  GET_SPARE_PART_REQUEST_LINES_BY_FILE_ID = 'SPARE_PART/REQUEST_LINES/GET_SPARE_PART_REQUEST_LINES_BY_FILE_ID',
}

export const GET_SPARE_PART_REQUEST_LINES_BY_FILE_ID = createRequest(
  ACTION_TYPES.GET_SPARE_PART_REQUEST_LINES_BY_FILE_ID,
);
